import React, { useState, useEffect } from 'react'
import "./CustomDatatableAgent.css";
import { FaPencilAlt, FaUserCheck, FaUserTimes } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import { BiEdit } from "react-icons/bi"
import DeleteConfirmation from '../DeleteConfirmation/DeleteConfirmation';
import BlockUnblockAgent from '../BlockUnblockAgent/BlockUnblockAgent';
import Pagination from '../Pagination/Pagination';
import { deleteAgent, getAgents, lockAgent, unlockAgent } from '../../services/http';
import { toast } from 'react-toastify';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { reload } from '../../utils/utils';



const CustomDatatableAgent = (props) => {

    const { columns, 
            data,
            changePage, 
            pageCount, 
            pageNumber, 
            perPage, 
            handleShowDeleteModal, 
            handleShowBlockUnblockModal, 
            handleCloseBlockUnblockModal, 
            handleCloseDeleteModal } = props;

    const navigate = useNavigate();
  const dispatch = useDispatch();
  const states = useSelector((state) => state, shallowEqual);
  const [processOngoing, setProcessOngoing] = useState(false)

    const handleYesClicked = async (idAgent) => {
setProcessOngoing(true)
        const reqdata = await deleteAgent(idAgent, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status !== 404 && reqdata.response.status !== 500) {
                let errorMsg = reqdata.response?.data.error;
  
                toast.error(errorMsg, {
                    position: toast.POSITION.TOP_RIGHT,
                    className: 'rotateY animated'
                });
            } else {
                //    Should redirect to an Error Page
                console.log(reqdata.response.data?.message)
                toast.error(reqdata.response?.data.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    className: 'rotateY animated'
                });
            }
        } else {
            let response = await getAgents(states.userToken.access_token, 1, "");
  
            let response_copy = response.data?.data?.map(obj => ({ ...obj, showBlock: false, showUnblock: false, showDelete: false }))
  
            dispatch({
                type: "SET",
                key: "agentList",
                payload: response_copy,
            });
  setProcessOngoing(false)
            toast.success("Agent supprimé avec succès !", {
                position: toast.POSITION.TOP_RIGHT,
                className: 'rotateY animated'
            });
        }
  
    }

    const handleYesBlockClicked = async (id) => {
        setProcessOngoing(true)
        const lock_agent_response = await lockAgent(id, states.userToken.access_token)
        console.log(id)
        console.log(states.userToken.access_token)
        if(lock_agent_response.response && lock_agent_response.response.statut !== 200) {
            console.log(lock_agent_response.response)
            toast.error(lock_agent_response.response?.data.error, {
                position: toast.POSITION.TOP_RIGHT,
                className: 'rotateY animated'
            });
        } else {
            console.log(lock_agent_response)
            setProcessOngoing(false)
            toast.success("Agent bloqué avec succès !", {
                position: toast.POSITION.TOP_RIGHT,
                className: 'rotateY animated'
            });
            let response = await getAgents(states.userToken.access_token, pageNumber, "");
  
            let response_copy = response.data?.data.map(obj => ({ ...obj, showBlock: false, showUnblock: false, showDelete: false }))
  
            dispatch({
                type: "SET",
                key: "agentList",
                payload: response_copy,
            });
            
           }
    }

    const handleYesUnblockClicked = async (id) => {
        setProcessOngoing(true)
        const unlock_agent_response = await unlockAgent(id, states.userToken.access_token)
        if(unlock_agent_response.response && unlock_agent_response.response.statut !== 200) {
            console.log(unlock_agent_response.response)
            toast.error(unlock_agent_response.response?.data.error, {
                position: toast.POSITION.TOP_RIGHT,
                className: 'rotateY animated'
            });
        } else {
            setProcessOngoing(false)
            console.log(unlock_agent_response)
            toast.success("Agent débloqué avec succès !", {
                position: toast.POSITION.TOP_RIGHT,
                className: 'rotateY animated'
            });
            let response = await getAgents(states.userToken.access_token, pageNumber, "");
  
            let response_copy = response.data?.data?.map(obj => ({ ...obj, showBlock: false, showUnblock: false, showDelete: false }))
            dispatch({
                type: "SET",
                key: "agentList",
                payload: response_copy,
            });
           }
    }

    return (
        <>

<div className="table-responsive ">
            <table className="table table-striped dataTable w-100">
                <thead className="">
                    <tr role={"row"}>
                        {columns && columns.map((item, index) =>
                            <th className={item.label == "#" ? "text-left pl-4" :"text-left pl-3"} aria-sort="ascending" >
                                {item.label}</th>
                        )}
                        <th className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length != 0 ? data?.map((item, index) =>
                        <tr key={index+"wcda"}>
                            
                            <td className="text-left pl-4">{pageNumber > 1 ? (perPage*(pageNumber-1) + (index + 1)) : (index+1)}</td>
                            
                            <td className="text-left pl-3">
                                            {item.nom}
                                        </td>
                                        <td className="text-left pl-3">
                                            {item.prenom}
                                        </td>
                                        <td className="text-center">
                                            {item.sexe}
                                        </td>
                                        <td className="text-left pl-3">
                                            {item.telephone}
                                        </td>
                                        <td className="text-left pl-3">
                                            {item.email}
                                        </td>
                                        <td className="text-left pl-3">
                                            {item.institution?.libelle}
                                        </td>
                           
                            <td className="d-flex flex-nowrap text-center pl-5 justify-content-around">
                                <BiEdit onClick={() => navigate(`/agent/${item.id}`)} title="Modifier" style={{ fill: "#2196F3", height: 25, width: 30, padding: 2, cursor: "pointer" }} className="custom-edit-button mr-1" />                               
                                {/* { item.id !== states.userInfo.id && <MdDeleteForever onClick={() => handleShowDeleteModal(item.id)} title="Supprimer" style={{ fill: "red", height: 25, width: 30, padding: 2, cursor: "pointer" }} className="custom-delete-button ml-1" />} */}
                                {item.id !== states.userInfo.id && item.isBlocked == 1 && <FaUserCheck onClick={() => handleShowBlockUnblockModal(item.id, "unblock")} title="Débloquer" style={{ height: 25, width: 25, padding: 2, cursor: "pointer" }} className="ml-1"/>}
                                {item.id !== states.userInfo.id && item.isBlocked == 0 && <FaUserTimes onClick={() => handleShowBlockUnblockModal(item.id, "block")} title="Bloquer" style={{ height: 25, width: 25, padding: 2, cursor: "pointer" }} className="ml-1"/>}
                            </td>
                            <DeleteConfirmation processOngoing={processOngoing} handleYesClicked={handleYesClicked}  title={` l'agent ${item.prenom} ${item.nom} ?`} id={item.id} show={item.showDelete} handleNoClicked={handleCloseDeleteModal} />
                            <BlockUnblockAgent handleYesClicked={handleYesBlockClicked}  title={` l'agent ${item.prenom} ${item.nom} ?`} id={item.id} show={item.showBlock} handleNoClicked={() => handleCloseBlockUnblockModal(item.id, "block")} />
                            <BlockUnblockAgent handleYesClicked={handleYesUnblockClicked}  title={` l'agent ${item.prenom} ${item.nom} ?`} id={item.id} show={item.showUnblock} handleNoClicked={() => handleCloseBlockUnblockModal(item.id, "unblock")} />
                        </tr>
                    ) : <h1 className="ok"></h1>}
                </tbody>
            </table>
            <Pagination pageCount={pageCount} changePage={changePage} />
        </div>
        </>
    )
}

export default CustomDatatableAgent